import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

const SuccessPage = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const schoolId = params.get("schoolId");

  const [status, setStatus] = useState("waiting"); // waiting | active | timeout

  useEffect(() => {
    if (!schoolId) return;

    const schoolRef = doc(db, "schools", schoolId);

    let attempts = 0;

    const interval = setInterval(async () => {
      attempts++;

      try {
        const snap = await getDoc(schoolRef);

        if (snap.exists()) {
          const data = snap.data();

          if (data.paymentStatus === "active") {
            clearInterval(interval);
            setStatus("active");

            setTimeout(() => {
              navigate("/login");
            }, 1500);
          }
        }
      } catch (err) {
        console.error("Error checking payment:", err);
      }

      // ⛑ fallback after ~20 seconds
      if (attempts > 10) {
        clearInterval(interval);
        setStatus("timeout");
      }
    }, 2000);

    return () => clearInterval(interval);
  }, [schoolId, navigate]);

  return (
    <div style={{ textAlign: "center", marginTop: "4rem" }}>
      {status === "waiting" && (
        <>
          <h1>🎉 Payment Successful!</h1>
          <p>Your school is being activated...</p>
          <p>This may take a few seconds.</p>
        </>
      )}

      {status === "active" && (
        <>
          <h1>✅ You're all set!</h1>
          <p>Redirecting you to login...</p>
        </>
      )}

      {status === "timeout" && (
        <>
          <h1>⚠️ Still processing...</h1>
          <p>
            Your payment went through, but activation is taking longer than expected.
          </p>
          <button
            onClick={() => navigate("/login")}
            style={{
              marginTop: "1rem",
              padding: "0.6rem 1rem",
              borderRadius: "6px",
              background: "#2563eb",
              color: "#fff",
              border: "none",
              cursor: "pointer",
            }}
          >
            Go to Login
          </button>
        </>
      )}

      {schoolId && <p><small>School ID: {schoolId}</small></p>}
    </div>
  );
};

export default SuccessPage;